import { Provincia } from "./../../_model/";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { config } from "environments/config";

@Injectable({
    providedIn: "root",
})
export class ProvinciaService {
    constructor(private http: HttpClient) {}

    getListProvincia() {
        return this.http
            .get<any>(`${config.apiUrl}/provincia/listar`)
            .toPromise()
            .then((res) => <Provincia[]>res.data)
            .then((data) => {
                return data;
            });
    }
}
